import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { RentalIntakeItem } from "@/models/rental-intake-item.model"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { useStoreBaseFunctions } from "@/composables/store/store-base-functions"
import { RentalIntakeItemRepository } from "@/repositories/rental-intake-item-repository"

export const useRentalIntakeItemStore = defineStore("rentalIntakeItemStore", () => {
  const rentalIntakeItems: Ref<RentalIntakeItem[]> = ref([])

  useSocketSynchronizationHandlers(RentalIntakeItem, rentalIntakeItems)

  const { fetchModels: fetchRentalIntakeItems, saveModel: saveRentalIntakeItem } =
    useStoreBaseFunctions(RentalIntakeItem, RentalIntakeItemRepository, rentalIntakeItems)

  return {
    rentalIntakeItems,
    fetchRentalIntakeItems,
    saveRentalIntakeItem
  }
})
